import { Heading, XStack, YStack } from '@my/ui'
import { AccordianBlock } from './accordian.block'
import { BlockRenderer } from '../block-renderer'
import { BlockToComponentMap } from '../block-mappings'
import { useState } from 'react'
import { ChevronDown, ChevronUp } from '@tamagui/lucide-icons'

interface AccordianEntryProps extends AccordianBlockProps {
  entry: AccordianBlock['entries'][number]
}

export interface AccordianBlockProps extends AccordianBlock {
  components: BlockToComponentMap
  depth: number
}

const AccordianEntryComponent = (props: AccordianEntryProps) => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <YStack pb="$2" width="100%" borderBottomWidth={2} borderColor="$gray7">
      <XStack
        justifyContent="space-between"
        onPress={() => setIsOpen(!isOpen)}
        cursor="pointer"
        alignItems="center"
        pb="$2"
      >
        <Heading size="$7" fow="600">
          {props.entry.title}
        </Heading>
        {!isOpen ? <ChevronDown size={30} /> : <ChevronUp size={30} />}
      </XStack>
      {isOpen && (
        <BlockRenderer
          content={props.entry.content}
          additionalComponents={props.components}
          depth={props.depth + 1}
          componentContainerProps={{
            gutter: false,
          }}
        />
      )}
    </YStack>
  )
}

export const AccordianComponent = (props: AccordianBlockProps) => {
  return (
    <YStack gap="$2.5">
      {props.entries.map((column, index) => (
        <AccordianEntryComponent {...props} key={`entry-${index}`} entry={column} />
      ))}
    </YStack>
  )
}
